import { trpc } from '@/shared/api';

/** 상품 상세를 무효화하고 다시 읽기가 끝날 때까지 기다린다 — 서버가 상품을 바꾼 직후 화면이 새 값으로 이어 가야 할 때 쓴다. */
export const useRefreshProductDetail = (): ((id: string) => Promise<void>) => {
  const utils = trpc.useUtils();

  return (id) => utils.productManagement.products.get.invalidate({ id });
};
